import { render } from "./ProductDetailDialog.vue?vue&type=template&id=92d08bc8&scoped=true&ts=true"
import script from "./ProductDetailDialog.vue?vue&type=script&lang=ts"
export * from "./ProductDetailDialog.vue?vue&type=script&lang=ts"

import "./ProductDetailDialog.vue?vue&type=style&index=0&id=92d08bc8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d08bc8"]])

export default __exports__